import { render } from "./TarotSpread.vue?vue&type=template&id=8db343ba&scoped=true"
import script from "./TarotSpread.vue?vue&type=script&lang=js"
export * from "./TarotSpread.vue?vue&type=script&lang=js"

import "./TarotSpread.vue?vue&type=style&index=0&id=8db343ba&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8db343ba"]])

export default __exports__